import { FormControl, FormGroup } from '@angular/forms';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';

export class OrganizeFormFactory {
	public static create(): IFormGroup<{ name: string; website: string }> {
		return new FormGroup({
			name: new FormControl(null, [SharedFormValidators.required]),
			website: new FormControl(null, [SharedFormValidators.required, SharedFormValidators.url]),
		}) as IFormGroup;
	}
	public static createForImage(image: string): IFormGroup<{ image: any }> {
		return new FormGroup({
			image: new FormControl(image, [SharedFormValidators.required]),
		}) as IFormGroup;
	}
}
